import {whatsAppTemplatesMixin} from './WhatsAppTemplatesMixin'

export const whatsAppTemplateMixin = {
    mixins: [whatsAppTemplatesMixin],
    props: {
    },
    data: function() {
        return {}
    },
    computed: {
        isUnderReview: function () {
            return this.template.status === 'under-review';
        },
        isApproved: function () {
            return this.template.status === 'approved';
        },
        isRejected: function () {
            return this.template.status === 'rejected';
        },
        statusForDisplay: function () {
            return this.templateStatusForDisplay(this.template);
        }
    },
    methods: {
    },
}